import * as React from "react";
const SvgFiRr6 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-6_svg__a)">
      <path
        fill="#062147"
        d="M17.77 10.514c-1.508-1.586-3.51-2.479-5.639-2.513-2.152-.013-4.202.781-5.742 2.296q-.203.2-.389.41v-.708c0-4.411 3.59-8 8-8h3a1 1 0 0 0 0-2h-3C8.486 0 4 4.486 4 10c0 0-.005 6.087 0 6.129.185 4.245 3.467 7.666 7.612 7.862q.196.009.391.009a7.94 7.94 0 0 0 5.416-2.115 7.94 7.94 0 0 0 2.576-5.602c.073-2.101-.738-4.203-2.226-5.769M12 22a6 6 0 1 1 0-12 6 6 0 1 1 0 12"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-6_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRr6;
